// Moved to @kenkaiiii/gg-core.
export { getClaudeCodeVersion, getClaudeCliUserAgent } from "@kenkaiiii/gg-core";
